import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useDocumentMeta } from "../hooks/use-document-meta";

/**
 * NotFound — 404 page, consistent with the V2 visual language.
 * Reuses existing utility classes (font-display, text-gradient-gold,
 * btn-pill, btn-primary-v2, btn-secondary-v2). No new styles introduced.
 */
export default function NotFound() {
  useDocumentMeta({
    title: "Page introuvable",
    description: null,
    canonicalPath: null,
    robots: "noindex",
  });
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <main
      data-testid="not-found-page"
      className="bg-fd-bg min-h-[100svh] flex items-center justify-center px-6 md:px-10 lg:px-14 pt-32 pb-24"
    >
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-3xl text-center"
      >
        <div className="mono-label-gold mb-6 flex items-center justify-center gap-3">
          <span className="w-10 h-px bg-fd-gold"></span>
          <span>404 · Page introuvable</span>
          <span className="w-10 h-px bg-fd-gold"></span>
        </div>

        <h1 className="display-xl text-[3.2rem] sm:text-7xl lg:text-[9rem] leading-[0.88] text-fd-text">
          Cette page <br />
          <span className="text-gradient-gold">n'est pas au menu.</span>
        </h1>

        <p className="font-body text-base md:text-lg text-fd-text/65 mt-8 max-w-xl mx-auto">
          L'adresse a peut-être changé, ou la page n'existe plus. Pas de panique : tout le catalogue reste à un clic.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/" data-cursor-hover className="btn-pill btn-primary-v2" data-testid="notfound-cta-home">
            Retour à l'accueil <ArrowUpRight size={16} />
          </Link>
          <Link to="/catalogue" data-cursor-hover className="btn-pill btn-secondary-v2" data-testid="notfound-cta-catalog">
            Voir les 13 gammes
          </Link>
        </div>
      </motion.div>
    </main>
  );
}
